import { Component } from "@angular/core";

@Component({
	selector: "ui-small-card",
	templateUrl: "./small-card.component.html",
	styleUrls: ["./small-card.component.scss"],
	standalone: false,
})
export class SmallCardComponent {}
